
<template>
    
        <mars-view v-if="lawyerInfo" class="answer-lawyer-card-container"><mars-view v-if="lawyerInfo.avatar || lawyerInfo.imgUrl" class="avatar-box"><mars-image class="avatar" mode="scaleToFill" lazy-load="true" :src="lawyerInfo.avatar || lawyerInfo.imgUrl"></mars-image><mars-view v-if="lawyerInfo.identityInfo || lawyerInfo.expertIdent || lawyerInfo.isRegistered" class="v-icon"></mars-view></mars-view><mars-view class="main-info-box"><mars-view class="top-box lineclamp1"><mars-text class="name">{{ lawyerInfo.lawyerName || lawyerInfo.name || lawyerInfo.uname }}</mars-text><mars-text v-if="lawyerInfo.registerYears" class="year">执业{{ lawyerInfo.registerYears }}年</mars-text><mars-text v-else-if="lawyerInfo.pranticeYear" class="year">{{ lawyerInfo.pranticeYear }}</mars-text></mars-view><mars-view class="bottom-box lineclamp1"><mars-text class="law-firm">{{ lawyerInfo.registerLawFirm || lawyerInfo.pracCompany }}</mars-text><mars-text v-if="domain" class="law-domain">{{ domain }}</mars-text></mars-view></mars-view></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
export default {
  props: {
    // 律师信息
    lawyerInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    // 擅长领域
    domain() {
      return this.lawyerInfo.lawDomain && this.lawyerInfo.lawDomain.join('、') || '';
    }
  }
};
</script>

<style scoped>
.answer-lawyer-card-container {
  display: flex;
  align-items: center;
}
.answer-lawyer-card-container .lineclamp1 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.answer-lawyer-card-container .avatar-box {
  position: relative;
  flex-shrink: 0;
  height: 9.82vw;
}
.answer-lawyer-card-container .avatar-box .avatar {
  display: block;
  width: 9.82vw;
  height: 9.82vw;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 50%;
}
.answer-lawyer-card-container .avatar-box .v-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 3.38vw;
  height: 3.38vw;
  background-size: 100% 100%;
  background-image: url('https://iknow-pic.cdn.bcebos.com/4e4a20a4462309f7184e3a80600e0cf3d7cad67b?x-bce-process=image/quality,q_80');
}
.answer-lawyer-card-container .main-info-box {
  padding-left: 1.85vw;
  flex: 1;
  font-size: 3.38vw;
  font-family: PingFang SC;
  color: #848691;
  line-height: 4.19vw;
}
.answer-lawyer-card-container .main-info-box .name {
  font-family: PingFang SC;
  color: #1e1f24;
  font-weight: 700;
}
.answer-lawyer-card-container .main-info-box .year {
  margin-left: 1.93vw;
}
.answer-lawyer-card-container .main-info-box .bottom-box {
  margin-top: 0.89vw;
}
.answer-lawyer-card-container .main-info-box .bottom-box .law-firm {
  vertical-align: middle;
}
.answer-lawyer-card-container .main-info-box .bottom-box .law-domain {
  margin-left: 1.93vw;
}

</style>
